import type { CustomOptionGroup, CustomOptionInputType, CustomOptionPreset } from "../../api/products";
import { cloneGroups, uniqueCode } from "./model";

// View adapter only. Existing IDs, codes, config and inactive options survive unchanged.
export function libraryGroups(presets: readonly CustomOptionPreset[]): CustomOptionGroup[] {
  const copies = JSON.parse(JSON.stringify(presets)) as CustomOptionPreset[];
  return copies.map(preset => ({ ...preset, productId: "public-library",
    values: preset.values.map(value => ({ ...value, groupId: preset.id, extraConfig: null })) }));
}
export function addLibraryGroup(groups: CustomOptionGroup[], name: string, inputType: CustomOptionInputType = "SINGLE_SELECT"): CustomOptionGroup[] {
  const trimmed = name.normalize("NFKC").trim();
  if (!trimmed || trimmed.length > 100) throw new Error("大类名称需为 1–100 个字符");
  if (groups.some(group => group.name.normalize("NFKC").trim() === trimmed)) throw new Error("已有同名大类，请直接编辑原大类");
  const now = new Date().toISOString();
  return [...cloneGroups(groups), { id: `draft:${crypto.randomUUID()}`, productId: "public-library", code: uniqueCode(), name: trimmed,
    inputType, required: false, unit: null, config: null, sortOrder: Math.max(-1, ...groups.map(group => group.sortOrder)) + 1,
    isActive: true, values: [], createdAt: now, updatedAt: now }];
}
export function appendBlankLibraryGroup(groups: CustomOptionGroup[]): CustomOptionGroup[] {
  const placeholder = `未命名_${crypto.randomUUID()}`;
  const next = addLibraryGroup(groups, placeholder);
  next[next.length - 1].name = "";
  return next;
}
